module.exports = __webpack_public_path__ + "img/payment.870d272f.svg";